import { Link } from "react-router-dom";
import React from "react";
import CheetahImage from "../assets/Cheetah.jpeg";
import FoxImage from "../assets/Fox.jpeg";
import RabbitImage from "../assets/Rabbit.jpeg";
import SlothImage from "../assets/Sloth.jpeg";
import TurtleImage from "../assets/Turtle.jpeg";
import CaterpillarImage from "../assets/Caterpillar.jpeg";

const Results = ({ WPM, CPM, mstk, acc, spScore, misPenal, points }) => {
  let h4, p;
  let imageSrc;

  if (WPM >= 90) {
    h4 = "You're a Typing Cheetah! 🐆🚀 ";
    p = "Blazing through with lightning-fast accuracy! Keep up the turbo-typing!";
    imageSrc = CheetahImage;
  } else if (WPM >= 70) {
    h4 = "You're a Quick Fox! 🦊⚡ Swift and precise. Keep practicing!";
    p = "You're leaving others in the dust! Keep sharpening those claws!";
    imageSrc = FoxImage;
  } else if (WPM >= 40) {
    h4 = "You're a Steady Rabbit! 🐇🌟 ";
    p = "Moving along at a comfortable pace, You are improving with each hop faster!";
    imageSrc = RabbitImage;
  } else if (WPM >= 20) {
    h4 = "You're a Determined Sloth! 🦥📈";
    p = " Consistently working hard to improve your typing speed! Keep inching forward, you're making progress!";
    imageSrc = SlothImage;
  } else if (WPM >= 15) {
    h4 = "You're a Persistent Turtle! 🐢🔄";
    p = " Steadily plodding along, every step counts..Keep practicing!!";
    imageSrc = TurtleImage;
  } else {
    h4 = "Keep Practicing, You're a Hungry Caterpillar! 🐛📚 ";
    p = "Every nibble brings you closer to becoming a butterfly of typing speed!";
    imageSrc = CaterpillarImage;
  }

  return (
    <>
      <div className="res-center">
        <div className="col resBox-width">
          <div className=" shadow-sm">
            <div className="box1-img">
              <img src={imageSrc} className="img-fluid" alt="Typing animal" />
            </div>
            <div className="card-body">
              <div className="message">
                <h1>{h4}!</h1>
                <p>{p}</p>
                <div className="scores-boxes">
                  <p>{Math.floor(WPM)}
                    <small>Words/min</small>
                  </p>
                  <p>{Math.floor(CPM)}
                    <small> Chars/min</small>
                  </p>
                  <p>{Math.floor(mstk)}
                    <small> Mistakes</small>
                  </p>
                  <p>{Math.floor(acc)}%
                    <small> Accuracy Score</small>
                  </p>
                  <p>{Math.floor(misPenal)}%
                    <small> Mistake Penalty</small></p>
                </div>
              </div>

              <Link to="/scoreboard" style={{ color: "black" }} className="playnowbtn">View Score Board</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Results;
